module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/ahand4-9c6b5d3a8e8b95ea9be7756e8d15c4f5.jpg";